import * as API from './API'

export default {
    //메일 일거리별 경쟁현황판 리스트 조회
    async getGroupTopic(currentPage, rowsPerPage, submissionStatus, uuid) {
        let parameters = {
            method: 'GET',
            path: '/p/api/group/topic',
            params: {
                page: currentPage,
                size: rowsPerPage,
                groupState: submissionStatus,
                topicUuid: uuid
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //경쟁현황판 리스트 조회
    async getGroupSubmission(currentPage, rowsPerPage, submissionStatus) {
        let parameters = {
            method: 'GET',
            path: '/api/group-submission',
            params: {
                page: currentPage,
                size: rowsPerPage,
                groupState: submissionStatus
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //경쟁현황 상세
    async getSubmissionDetail(currentPage, rowsPerPage, uuid) {
        let parameters = {
            method: 'GET',
            path: '/api/group-submission/' + uuid,
            params: {
                page: currentPage,
                size: rowsPerPage,
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    //경쟁현황 상세 - 해당 조 출품 리스트 조회
    async getSubmissionGroupList(groupUuid) {
        let parameters = {
            method: 'GET',
            path: '/api/group-submission/belong-to-group/' + groupUuid,
            params: {
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

}



// WEBPACK FOOTER //
// ./src/service/submissionAPI.js